/**
 * Returns a random AlphaNumeric string for the given size requested. This function is
 * not cryptographically secure.
 */
export function getRandomAlphaNumericString(stringLength: number) {
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  function pickRandom() {
    return possible[Math.floor(Math.random() * possible.length)];
  }

  return [...Array(stringLength)].map(pickRandom).join("");
}
